import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useUiStore } from './ui';

/**
 * One-way sync: URL is the source of truth on mount, and store changes
 * propagate to URL. The component that renders this should live inside
 * <Router>. Values that don't parse fall back to store defaults.
 */
export function useUrlSync(): void {
  const [params, setParams] = useSearchParams();
  const year = useUiStore((s) => s.year);
  const month = useUiStore((s) => s.month);

  // Read URL → store on mount and whenever URL changes
  useEffect(() => {
    const y = Number(params.get('year'));
    const m = Number(params.get('month'));
    const st = useUiStore.getState();
    if (Number.isInteger(y) && y >= 1900 && y <= 2200 && y !== st.year) {
      st.setYear(y);
    }
    if (Number.isInteger(m) && m >= 0 && m <= 11 && m !== st.month) {
      st.setMonth(m);
    }
  }, [params]);

  // Write store → URL when they diverge
  useEffect(() => {
    const currentY = Number(params.get('year'));
    const currentM = Number(params.get('month'));
    if (currentY !== year || currentM !== month) {
      const next = new URLSearchParams(params);
      next.set('year', String(year));
      next.set('month', String(month));
      setParams(next, { replace: true });
    }
  }, [year, month, params, setParams]);
}
